//审批通知
<template>
  <div class="detail">
    <div class="card" v-if="data.auditStatus == 2">
      <div class="title">驳回理由</div>
      <div class="panel" style="color: red;">
        {{ data.rejectRemark || '暂无理由' }}
      </div>
    </div>
    <div class="card">
      <div class="title">
        被拜访人信息
      </div>
      <div class="panel">
        <div class="cell">
          <span class="headline">被访人姓名</span>
          <span>{{ data.acceptName }}</span>
        </div>
        <div class="cell">
          <span class="headline">预约时间</span>
          <span style="color: #454f63; font-size: 0.75rem;">{{
            data.time
          }}</span>
        </div>
        <div class="cell">
          <span class="headline">审批状态</span>
          <span style="color: #454f63; font-size: 0.75rem;">{{ status }}</span>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="title">
        拜访人信息
      </div>
      <div class="panel flex flex-vc border-b">
        <img :src="data.photoImg" alt="" @click="previewImg(data.photoImg)" />
        <div class="info">
          <div class="name">{{ data.initiatorName }}</div>
          <span class="phone" @click="getMobile(data, data.isShowMobile)">{{ data.isShowMobile ? data.noMobile :
      data.visitorPhone }}</span>
          <van-icon class="phone" style="margin-left: 3px;" @click="getMobile(data, data.isShowMobile)"
            v-if="!data.isShowMobile" name="eye-o" />
          <van-icon class="phone" style="margin-left: 3px;" @click="getMobile(data, data.isShowMobile)"
            v-if="data.isShowMobile" name="closed-eye" />
        </div>
      </div>
    </div>
    <div class="person-list" v-if="personList.length > 0">
      <div class="person-header">
        <span>同行人员</span>
      </div>
      <div
        class="person-item flex flex-vc"
        v-for="(item, index) in personList"
        :key="index"
      >
        <div class="person-avatar">
          <img :src="item.photoImg" />
        </div>
        <div class="person-info flex-1">
          <div class="person-name">{{ item.visitorName }}</div>
          <span @click="getTeacherOrParentMobile(item, item.isShowMobile)" class="person-phone">{{ item.isShowMobile ?
      item.noMobile : item.visitorPhone }}</span>

          <van-icon class="person-phone" style="margin-left: 3px;"
            @click="getTeacherOrParentMobile(item, item.isShowMobile)"
            v-if="!item.isShowMobile && item.name != '该学生未绑定家长'" name="eye-o" />
          <van-icon class="person-phone" style="margin-left: 3px;"
            @click="getTeacherOrParentMobile(item, item.isShowMobile)" v-if="item.isShowMobile" name="closed-eye" />

        </div>
      </div>
    </div>
    <div class="card">
      <div class="title">
        其他信息
      </div>
      <div class="panel">
        <div class="cell">
          <span class="headline">所属单位</span>
          <span>{{ data.affiliatedUnit }}</span>
        </div>
        <div class="cell">
          <span class="headline">车牌号</span>
          <span>{{ data.carNumber }}</span>
        </div>
        <div class="cell">
          <span class="headline">预约事由</span>
          <span>{{ data.visitorGoal }}</span>
        </div>
        <div class="cell">
          <span class="headline">备注</span>
          <span>{{ data.remark }}</span>
        </div>
      </div>
    </div>
     <div class="card" v-if="data.visitorHealthCertificate && data.visitorHealthCertificate.length > 0">
      <div class="title_1">
        <span>预约人及同行人健康码</span> 
        <span style="font-size: 0.85rem;" v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 0))"> : 暂无</span> </div>
      <div class="panel_1" v-if="data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 0)">
        <img class="img_1"  @click="previewImg(img.imgUrl)" v-for="img in data.visitorHealthCertificate.filter(x => x.type == 0)" :key="img.imgUrl"  :src="img.imgUrl" alt="">
      </div>
      <div class="title_1">
        <span>预约人及同行人行程码</span>  <span v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 1))"> : 暂无</span>
      </div>
      <div class="panel_1" v-if=" data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 1)">
       <img class="img_1" @click="previewImg(img.imgUrl)" v-for="img in data.visitorHealthCertificate.filter(x => x.type == 1)" :key="img.imgUrl" :src="img.imgUrl" alt="">
      </div>
      <div class="title_1">
        <span>预约人及同行人核酸检测证明</span> <span v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 2))"> : 暂无</span>
      </div>
      <div class="panel_1" v-if=" data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 2)">
       <img class="img_1" @click="previewImg(img.imgUrl)" v-for="img in data.visitorHealthCertificate.filter(x => x.type == 2)" :key="img.imgUrl" :src="img.imgUrl" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { getDateYMD } from '@/utils'
import moment from 'moment'
import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      data: {},
      personList: [],
      nucleStatus:false
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    status() {
      let obj = {
        0: '待审批',
        1: '审批通过',
        2: '审批未通过',
        3: '拜访完成',
        4: '正在审批',
        '-1': '已过期',
      }
      return obj[this.data.auditStatus]
    },
  },
  mounted() {
    // console.log('审批通知query', this.$route.query)
    this.getSubDetail()
    this.getSysSchool()
  },
  methods: {
    
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      })
    },
    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getFollowMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol

      }
    },
     // 点击获取预约人手机号
     getMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getVisitorMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol
      }
    },
    // 详情
    async getSubDetail() {
      const { data, code } = await this.$https.getNoTokenDetail({
        visitorId: this.id,
        // visitorId: '1259321204982009856',
      })
      if (code !== 200) {
        this.$toast('获取详情失败')
        return false
      }
      data.isShowMobile = false
      this.data = data
      // this.data.visitorBeginTime = getDateYMD(data.visitorBeginTime)
      // this.data.visitorEndTime = moment(data.visitorEndTime).format('mm-ss')
      this.data.time =
        getDateYMD(data.visitorBeginTime) +
        '-' +
        moment(data.visitorEndTime).format('HH:mm')
      this.getPersonList(data.id)
    },
    async getPersonList(id) {
      const { data, code } = await this.$https.getNoTokenPersonDetail({
        visitorId: id,
        // visitorId: '1259321204982009856',
      })
      if (code !== 200) {
        this.$toast('获取人员失败')
        return false
      }
      data.forEach(item => {
        item.isShowMobile = false
      })
      this.personList = data.slice(1)
      console.log(this.personList);
    },
  },
}
</script>

<style lang="scss" scoped>
.border-b {
  border-bottom: 1px solid #f4f4f6;
}
.detail {
  padding-bottom: 10rem;
  padding-top: 1px;
}
.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem;
  border-radius: 0.75rem;
  .title {
    color: rgba(120, 132, 158, 1);
    font-size: 0.75rem;
    padding: 1rem 1.25rem;
  }
  .title_1 {
    color: rgba(120, 132, 158, 1);
    font-size: 0.85rem;
    padding: 0.6rem 1.25rem;
  }
  .panel {
    /* display: flex; */
    /* padding: 0rem 1rem 1rem 1rem; */
    margin: 0 1rem;
    padding-bottom: 1rem;
    /* align-items: center; */
    img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }
    .info {
      flex: 1;
      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }
      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }
    .or {
      margin: 0.5rem 0;
      color: #78849e;
    }
    .center {
      text-align: center;
    }
    .time {
      font-size: 1rem;
      color: #78849e;
    }
  }
   .panel_1 {
    /* display: flex; */
    /* padding: 0rem 1rem 1rem 1rem; */
    padding: 1rem 0;
    margin: 0 1rem;
     border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    // padding-bottom: 1rem;
    /* align-items: center; */
    .hint {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
      margin-bottom: 0.75rem;
    }
    .invite-btn {
      margin: 0.5rem 0;
      span {
        padding: 0.65rem 1rem;
        display: inline-block;
        color: rgba(120, 132, 158, 1);
        background: rgba(233, 235, 239, 1);
        font-size: 0.75rem;
        border-radius: 0.85rem;
      }
    }
    .img_1 {
      width: 4rem;
      height: 4rem;
      border-radius: .4rem;
      margin-right: 0.75rem;
      object-fit: cover;
    }
    .img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }
    
    .info {
      flex: 1;
      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }
      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }
    .or {
      margin: 0.5rem 0;
      color: #78849e;
    }
    .center {
      text-align: center;
    }
    .time {
      font-size: 1rem;
      color: #78849e;
    }
  }
}
.cell {
  padding: 0.5rem 0;
  color: #454f63;
  font-size: 0.875rem;

  .headline {
    display: inline-block;
    color: #78849e;
    font-size: 0.75rem;

    margin-right: 1rem;
    width: 4rem;
    text-align: right;
  }
}
.dialog-wrap {
  /* padding: 20px; */
  .wrap {
    padding: 10px;
    display: flex;
    flex-direction: column;
    .title {
      text-align: center;
      margin: 1rem 0;
      color: red;
    }
    .remak {
      outline: none;
      border: none;
      background: #f7f7fa;
      padding: 10px 15px;
      border-radius: 30px;
      margin: 10px 0 20px 0;
    }
  }
}
.btn-group {
  width: 100%;
  margin-top: 2.5rem;
  /* left: 0; */
  .btn-wrap {
    padding: 0 2rem;
  }
}
.person-list {
  margin: 1rem 1rem 0;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #ffffff;
  border-radius: 0.75rem;
  .person-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    > span {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
    }
    > div {
      .iconfont {
        font-size: 0.75rem;
      }
      font-size: 0.875rem;
      color: rgba(52, 151, 253, 1);
    }
  }
  .person-item {
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    margin-bottom: 0.6rem;
    &:last-child {
      border-bottom: none;
    }
    .person-name {
      color: rgba(69, 79, 99, 1);
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 0.125rem;
    }
    .person-phone {
      color: rgba(120, 132, 158, 1);
      font-size: 0.875rem;
    }
    .person-avatar {
      margin-right: 1rem;
      img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.75rem;
        margin: 0 auto;
        display: block;
        object-fit: cover;
      }
    }
    .handle {
      background: rgba(233, 235, 239, 1);
      border-radius: 0.5rem;
      font-size: 0.6875rem;
      width: 5rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      color: rgba(120, 132, 158, 1);
    }
  }
}
</style>
